import PandaQuestion1 from "../../assets/images/Panda/PandaQuestion1.png";
import financeApp from "../../assets/images/storeImages/finance_app.jpg";
import plantsCayCoiApp from "../../assets/images/storeImages/plants_caycoi_app.jpg";
import shopFootApp from "../../assets/images/storeImages/shopfoot_app.jpg";
import voiceCameraApp from "../../assets/images/storeImages/voice_camera_app.jpg";
import SectionBannerStore from "../../components/main/SectionBannerStore";
import SectionExplore from "../../components/main/SectionExplore";
import SectionFeatureTemplate from "../../components/main/SectionFeatureTemplate";
import SectionQuestion from "../../components/main/SectionQuestion";
import SectionStore from "../../components/main/SectionStore";
import SEOHead from "../../components/common/SEOHead";
import JsonLd from "../../components/common/JsonLd";

const Store: React.FC = () => {
  const faqs = [
    {
      key: "1",
      q: "Giao diện tại TrioCore là mã nguồn đóng hay mở? Có dễ nâng cấp không?",
      a: "Các mẫu tại TrioCore được phát triển trên các nền tảng công nghệ hiện đại, tối ưu mã nguồn sạch (Clean Code). Doanh nghiệp hoàn toàn có thể tự phát triển mở rộng, nâng cấp tính năng hoặc tích hợp thêm phần mềm quản lý (CRM/ERP) bất cứ lúc nào mà không phải làm lại từ đầu.",
    },
    {
      key: "2",
      q: "Chi phí hiển thị trên kho giao diện đã bao gồm những gì?",
      a: "Chi phí tại TrioCore là chi phí tối ưu và minh bạch. Gói bàn giao đã bao gồm thiết kế giao diện chuẩn UX/UI, tối ưu cấu trúc kỹ thuật và hệ thống quản trị nội bộ dễ sử dụng. Chúng tôi không thu phí ẩn và có chính sách bảo hành kỹ thuật dài hạn.",
    },
    {
      key: "3",
      q: "TrioCore có hỗ trợ chỉnh sửa giao diện theo nhận diện thương hiệu riêng của tôi không?",
      a: "Có. Kho giao diện đóng vai trò là bộ khung giải pháp giúp rút ngắn thời gian triển khai. Đội ngũ kỹ sư và thiết kế của TrioCore sẽ tùy biến lại màu sắc, font chữ, bố cục và tính năng để đảm bảo sản phẩm phản ánh chính xác bản sắc thương hiệu và quy trình vận hành riêng của doanh nghiệp bạn.",
    },
    {
      key: "4",
      q: "Nếu tôi chọn một mẫu có sẵn, thời gian tùy biến và triển khai sẽ mất bao lâu?",
      a: "Thời gian triển khai thường được rút ngắn đáng kể so với làm mới hoàn toàn vì kho giao diện đã có sẵn cấu trúc nền tảng. Tùy theo mức độ tùy biến về giao diện, chức năng và tích hợp hệ thống, TrioCore sẽ khảo sát và đưa ra lộ trình triển khai rõ ràng để doanh nghiệp chủ động kế hoạch vận hành.",
    },
    {
      key: "5",
      q: "Sau khi bàn giao, doanh nghiệp có thể tự quản trị nội dung và mở rộng hệ thống không?",
      a: "Có. Chúng tôi ưu tiên xây dựng các nền tảng dễ quản trị, dễ cập nhật và thuận tiện cho đội ngũ nội bộ sử dụng lâu dài. Khi bàn giao, TrioCore có thể hướng dẫn quy trình quản trị cơ bản, đồng thời thiết kế cấu trúc đủ mở để doanh nghiệp tiếp tục phát triển thêm tính năng khi cần.",
    },
    {
      key: "6",
      q: "TrioCore có hỗ trợ kỹ thuật và tối ưu thêm sau khi hệ thống đi vào vận hành không?",
      a: "Có. Bên cạnh giai đoạn bàn giao, TrioCore vẫn đồng hành ở phần bảo hành kỹ thuật, hỗ trợ xử lý lỗi, tối ưu hiệu năng và tư vấn mở rộng hệ thống khi doanh nghiệp phát sinh nhu cầu mới. Mục tiêu của chúng tôi là giúp nền tảng vận hành ổn định và tiếp tục tạo ra giá trị thực tế sau khi đưa vào sử dụng.",
    },
    {
      key: "7",
      q: "Doanh nghiệp chưa có cấu trúc nội dung hoặc chưa rõ luồng chức năng thì TrioCore có hỗ trợ tư vấn không?",
      a: "Có. Trước khi triển khai, TrioCore có thể đồng hành cùng doanh nghiệp ở giai đoạn làm rõ mục tiêu, cấu trúc nội dung, hành vi người dùng và luồng chức năng cần thiết. Điều này giúp hệ thống sau khi xây dựng bám sát bài toán kinh doanh thay vì chỉ dừng ở phần giao diện hiển thị.",
    },
    {
      key: "8",
      q: "Tôi có thể bắt đầu từ một phiên bản gọn trước rồi nâng cấp dần theo ngân sách không?",
      a: "Hoàn toàn được. Đây là cách triển khai phù hợp với nhiều doanh nghiệp đang cần đi nhanh nhưng vẫn kiểm soát chi phí. TrioCore có thể giúp bạn xây dựng phiên bản nền tảng trước, sau đó mở rộng dần các tính năng, tích hợp và hệ thống quản trị theo từng giai đoạn phát triển thực tế.",
    },
  ];

  const appSolutions = [
    {
      title: "Finance App",
      img: financeApp,
      label: "Dashboard tài chính",
      description: "Theo dõi số liệu, luồng tiền và báo cáo vận hành cho quản trị nội bộ.",
    },
    {
      title: "Plants Cây Cối",
      img: plantsCayCoiApp,
      label: "Mobile App dịch vụ",
      description: "Giao diện app cho đặt lịch, quản lý đơn và chăm sóc khách hàng theo quy trình.",
    },
    {
      title: "Shop Foot",
      img: shopFootApp,
      label: "App bán hàng",
      description: "Bộ khung mobile cho bán lẻ, giỏ hàng, sản phẩm và trạng thái đơn.",
    },
    {
      title: "Voice Camera",
      img: voiceCameraApp,
      label: "App công cụ nội bộ",
      description: "Khung giao diện phục vụ thao tác nhanh, quản lý nội dung hoặc hỗ trợ nghiệp vụ.",
    },
  ];

  return (
    <>
      <SEOHead
        title="Kho Giao Diện — TrioCore Solutions"
        description="Khám phá kho giao diện website mẫu hiện đại, đa dạng ngành nghề, chuẩn SEO và tối ưu UI/UX cho mọi nhu cầu kinh doanh của doanh nghiệp."
        path="/store"
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Trang chủ",
              "item": "https://triocoresolutions.com.vn/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Kho giao diện",
              "item": "https://triocoresolutions.com.vn/store"
            }
          ]
        }}
      />
      <SectionExplore />
      <SectionFeatureTemplate
        title="Nền tảng giải pháp mới cập nhật"
        description="Các cấu trúc mới được bổ sung liên tục để phục vụ nhu cầu triển khai web, dashboard, landing page và mobile UI theo bài toán vận hành thực tế."
      />
      <section className="w-full bg-gradient-to-b from-[#fff8f8] to-white py-12">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="mb-10 max-w-[760px]">
            <p className="text-left text-[26px] font-semibold leading-[1.2] text-[#2f1a1a] sm:text-[30px]">
              Giải pháp App Mobile & Dashboard vận hành
            </p>
            <p className="mt-3 text-left text-[15px] leading-8 text-slate-600">
              Bộ khung trình diễn các hướng triển khai mobile app và dashboard quản trị giúp doanh nghiệp quản lý
              nội bộ, vận hành đơn hàng, dữ liệu và các tác vụ chuyên biệt một cách gọn gàng hơn.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {appSolutions.map((item) => (
              <article
                key={item.title}
                className="flex h-full flex-col overflow-hidden rounded-[22px] border border-red-100 bg-white shadow-[0_14px_34px_rgba(127,29,29,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_44px_rgba(127,29,29,0.08)]"
              >
                <div className="h-[240px] overflow-hidden bg-[#f8f9fa]">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="h-full w-full object-cover object-center"
                    width="400"
                    height="240"
                    loading="lazy"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4 text-left">
                  <span className="inline-flex rounded-full border border-red-100 bg-red-50 px-2.5 py-1 text-[11px] font-medium text-red-700">
                    {item.label}
                  </span>
                  <p className="mt-3 text-[16px] font-semibold leading-6 text-[#2f1a1a]">{item.title}</p>
                  <p className="mt-2 text-[12.5px] leading-6 text-slate-600">{item.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      <SectionStore bg="white" value="Danh mục nền tảng số theo mục tiêu triển khai" />
      <SectionBannerStore />
      <SectionQuestion
        title="Câu hỏi thường gặp về thư viện giải pháp số"
        faqs={faqs}
        img={
          <img
            className="absolute -top-2 left-4 w-[430px] object-cover lg:-top-4 lg:left-2 lg:w-[400px] xl:w-[420px]"
            src={PandaQuestion1}
            alt="Panda Mascot"
            width="430"
            height="430"
            loading="lazy"
          />
        }
      />
    </>
  );
};

export default Store;
